var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "sc-dropdown",
        {
          staticClass: "card-dropdown",
          attrs: { "aria-role": "list", position: "is-bottom-left" }
        },
        [
          !_vm.schemaBased || _vm.schemaBased.version !== "v2"
            ? _c(
                "button",
                {
                  staticClass: "card-menu-button",
                  attrs: {
                    slot: "trigger",
                    type: "button",
                    id: "card-menu-" + this.integration.id
                  },
                  slot: "trigger"
                },
                [_c("sc-icon", { attrs: { icon: "ellipsis-v" } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "sc-dropdown-item",
            {
              staticClass: "card-dropdown-item",
              attrs: { disabled: this.integration.status === "UNINSTALLED" },
              on: {
                click: function() {
                  return _vm.handleEditIntegrationButton()
                }
              }
            },
            [
              _c(
                "span",
                [_c("sc-icon", { attrs: { icon: "pen" } }), _vm._v(" Editar ")],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "sc-dropdown-item",
            {
              staticClass: "card-dropdown-item",
              attrs: { disabled: this.integration.status === "UNINSTALLED" },
              on: {
                click: function() {
                  return _vm.handleMonitoringIntegrationButton()
                }
              }
            },
            [
              _c(
                "span",
                [
                  _c("sc-icon", { attrs: { icon: "heartbeat" } }),
                  _vm._v(" Monitorar ")
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "sc-dropdown-item",
            {
              staticClass: "card-dropdown-item",
              attrs: {
                id: "uninstall-item-" + this.integration.id,
                disabled: this.integration.status === "UNINSTALLED"
              },
              on: {
                click: function() {
                  return _vm.handleUninstallButton()
                }
              }
            },
            [
              _c(
                "span",
                [
                  _c("sc-icon", { attrs: { icon: "times" } }),
                  _vm._v(" Desinstalar ")
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "sc-dropdown-item",
            {
              staticClass: "card-dropdown-item",
              on: {
                click: function() {
                  return _vm.handleAboutIntegrationButton()
                }
              }
            },
            [
              _c(
                "span",
                [_c("sc-icon", { attrs: { icon: "info" } }), _vm._v(" Sobre ")],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "sc-dropdown-item",
            {
              staticClass: "card-dropdown-item",
              on: {
                click: function() {
                  return _vm.handleReportProblemIntegrationButton()
                }
              }
            },
            [
              _c(
                "span",
                [
                  _c("sc-icon", { attrs: { icon: "skull-crossbones" } }),
                  _vm._v(" Reportar problema\n      ")
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d622e41", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d622e41","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/components/app-list/app-card/header-card/menu-card/MenuCard.vue
// module id = null
// module chunks = 